import { render, staticRenderFns } from "./SsoSetPassword.vue?vue&type=template&id=da68198c"
import script from "./SsoSetPassword.vue?vue&type=script&lang=js"
export * from "./SsoSetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports